// extracted by mini-css-extract-plugin
module.exports = {"backgroundProgressBar":"ProgressBarStateCourse_backgroundProgressBar__2QUjG","fillerProgressBar":"ProgressBarStateCourse_fillerProgressBar__25jL3"};